import { PermissionFlag, ToggleOption } from "@/onboarding/features/bidding/types"

export const EDITABLE_OPTIONS: [ToggleOption, ToggleOption] = [
  { value: true, label: "Editable" },
  { value: false, label: "Locked" },
]

export const REQUIRED_OPTIONS: [ToggleOption, ToggleOption] = [
  { value: true, label: "Required" },
  { value: false, label: "Optional" },
]

export const flagLabel = (permissionFlag: PermissionFlag, value: boolean): string => {
  const [on, off] =
    permissionFlag === PermissionFlag.WRITEABLE ? EDITABLE_OPTIONS : REQUIRED_OPTIONS

  return value === on.value ? on.label : off.label
}
